import request from '@/utils/request'

function unwrap(promise, fallbackMsg) {
  return new Promise((resolve, reject) => {
    promise.then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
        return
      }
      reject(new Error(res.msg || fallbackMsg))
    }).catch(error => reject(error))
  })
}

export function queryBenefitLife(params) {
  return unwrap(request({
    url: '/benefitLife.query',
    method: 'get',
    params
  }), 'query benefit life failed')
}

export function saveBenefitLife(data) {
  return unwrap(request({
    url: '/benefitLife.save',
    method: 'post',
    data
  }), 'save benefit life failed')
}

export function updateBenefitLife(data) {
  return unwrap(request({
    url: '/benefitLife.update',
    method: 'post',
    data
  }), 'update benefit life failed')
}

export function benefitLifeAction(data) {
  return unwrap(request({
    url: '/benefitLife.action',
    method: 'post',
    data
  }), 'run benefit life action failed')
}
